const URL = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:21021/';
export default URL;